import Vue from 'vue'
import VuetifyConfirm from 'vuetify-confirm'

Vue.use(VuetifyConfirm, {
  buttonTrueText: 'Ja',
  buttonTrueColor: 'success',
  buttonFalseText: 'Nein',
  buttonFalseColor: 'error',
  color: 'warning',
  icon: 'fal fa-warning',
  title: 'Achtung',
  width: 350,
  property: '$confirm'
})
